import css from './index.module.scss';
import { getLang } from 'lowcomp/plugins/member/utils';
import { i18n } from '../i18n';
import { useRouter } from 'next/router';

export default function Countdown({ dateObj, eventCountBgColor, eventCountNumberColor, eventCountTextColor }: any) {
    const { locale = 'us' } = useRouter();
    const t = getLang(i18n, locale);

    return (
        <>
            {(dateObj?.d >= 0 || dateObj?.h >= 0 || dateObj?.m >= 0 || dateObj?.s >= 0) && (
                <div className={`flash-sale-countdown ${css['flash-sale-countdown']}`}>
                    {dateObj?.d >= 0 && (
                        <div className="day-box date-list" style={{ backgroundColor: eventCountBgColor }}>
                            <div className="box-inner">
                                <span className="day date-number" style={{ color: eventCountNumberColor }}>
                                    {dateObj?.d}
                                </span>
                                <span className="day-text date-text" style={{ color: eventCountTextColor }}>
                                    {/* {dateObj?.d === '01' ? t('countdown_day') : t('countdown_days')} */}
                                    {t('countdown_days')}
                                </span>
                            </div>
                            <span className="after" style={{ color: eventCountTextColor }}>
                                :
                            </span>
                        </div>
                    )}
                    {dateObj?.h >= 0 && (
                        <div className="hour-box date-list" style={{ backgroundColor: eventCountBgColor }}>
                            <div className="box-inner">
                                <span className="hour date-number" style={{ color: eventCountNumberColor }}>
                                    {dateObj?.h}
                                </span>
                                <span className="hour-text date-text" style={{ color: eventCountTextColor }}>
                                    {/* {dateObj?.h === '01' ? t('countdown_hour') : t('countdown_hours')} */}
                                    {t('countdown_hours')}
                                </span>
                            </div>
                            <span className="after" style={{ color: eventCountTextColor }}>
                                :
                            </span>
                        </div>
                    )}
                    {dateObj?.m >= 0 && (
                        <div className="minute-box date-list" style={{ backgroundColor: eventCountBgColor }}>
                            <div className="box-inner">
                                <span className="minute date-number" style={{ color: eventCountNumberColor }}>
                                    {dateObj?.m}
                                </span>
                                <span className="minute-text date-text" style={{ color: eventCountTextColor }}>
                                    {/* {dateObj?.m === '01' ? t('countdown_minute') : t('countdown_minutes')} */}
                                    {t('countdown_minutes')}
                                </span>
                            </div>
                            <span className="after" style={{ color: eventCountTextColor }}>
                                :
                            </span>
                        </div>
                    )}
                    {dateObj?.s >= 0 && (
                        <div className="second-box date-list" style={{ backgroundColor: eventCountBgColor }}>
                            <div className="box-inner">
                                <span className="second date-number" style={{ color: eventCountNumberColor }}>
                                    {dateObj?.s}
                                </span>
                                <span className="second-text date-text" style={{ color: eventCountTextColor }}>
                                    {/* {dateObj?.s === '01' ? t('countdown_second') : t('countdown_seconds')} */}
                                    {t('countdown_seconds')}
                                </span>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </>
    );
}
